import { Skeleton } from '@qodo/design-system';

type UpgradeNowSkeletonProps = {
  collapsed: boolean;
};

export const UpgradeNowSkeleton = ({ collapsed }: UpgradeNowSkeletonProps) => {
  if (collapsed) {
    return (
      <div className="mx-4 flex w-[calc(100%-16px)] justify-center p-4">
        <Skeleton className="size-4 rounded" />
      </div>
    );
  }

  return (
    <div className="mx-auto flex h-[145px] w-[calc(100%-16px)] flex-col gap-4 rounded-md border border-border-panel-neutral px-4 pt-4 pb-2">
      <Skeleton className="h-3 w-24 rounded" />
      <Skeleton className="h-3 w-40 rounded" />
      <Skeleton className="h-3 w-20 rounded" />
    </div>
  );
};
